module.exports = __webpack_public_path__ + "img/compass-app-icon.185a26b9.jpg";